import { FC, PropsWithChildren } from 'react';

import {
  QueryClientProvider,
  QueryClient as TanstackQueryClient
} from '@tanstack/react-query';

const queryClient = new TanstackQueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

/**
 * Провайдер для QueryClient
 * @param root0 Пропсы
 * @param root0.children Дочерние элементы
 */
export const QueryClient: FC<PropsWithChildren> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
